var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0V0C31.0457 0 40 8.95431 40 20V20C40 31.0457 31.0457 40 20 40V40C8.95431 40 0 31.0457 0 20V20Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0214 14.9205L25.053 11.9522C24.6656 11.5883 24.158 11.3795 23.6267 11.3655C23.0953 11.3515 22.5774 11.5333 22.1714 11.8763L12.4214 21.6263C12.0712 21.9795 11.8532 22.4423 11.8039 22.9372L11.338 27.4547C11.3235 27.6133 11.344 27.7733 11.3983 27.9231C11.4527 28.0729 11.5393 28.2089 11.6522 28.3213C11.7534 28.4217 11.8735 28.5012 12.0055 28.5551C12.1375 28.609 12.2788 28.6363 12.4214 28.6355H12.5189L17.0364 28.2238C17.5312 28.1745 17.9941 27.9565 18.3472 27.6063L28.0972 17.8563C28.4756 17.4566 28.6802 16.9231 28.6659 16.3728C28.6517 15.8224 28.4199 15.3002 28.0214 14.9205V14.9205ZM16.8414 26.0572L13.5914 26.3605L13.8839 23.1105L20.0047 17.0655L22.9297 19.9905L16.8414 26.0572ZM24.338 18.5388L21.4347 15.6355L23.5472 13.4688L26.5047 16.4263L24.338 18.5388Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditHover);
export default __webpack_public_path__ + "edit-hover.c5f313dc774e7b6b3e567a68077fe6ff.svg";
export { ForwardRef as ReactComponent };